import { createSlice } from "@reduxjs/toolkit";
import { User } from "../../@types/user";
import { findUser } from "./actions/find-user";
import { updateUser } from "./actions/update-user";
import { changeUserEmail } from "./actions/change-user-email";
interface UserState {
  user: User;
}

const initialState = {
  user: {},
} as UserState;

const userUpdateSlice = createSlice({
  name: "userUpdate",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(findUser.fulfilled, (state, { payload }) => {
      state.user = payload;
    });
    builder.addCase(updateUser.fulfilled, (state, { payload }) => {
      state.user = { ...state.user, name: payload.name, dni: payload.dni };
    });
    builder.addCase(changeUserEmail.fulfilled, (state, { payload }) => {
      if (payload.migsUpdated && payload.email) {
        state.user.email = payload.email;
      }
    });
  },
});

export default userUpdateSlice.reducer;
